<div class="e-help-resources-layout" id="top">
    <ng-content></ng-content>
</div>
